import { useEffect } from 'react';
import { KEYBOARD } from 'modules/constants';
export function useEscapeCallback(options) {
    const { active, callback, elements } = options;
    const allElements = Array.isArray(elements) ? elements : [elements];
    const keyListener = (event) => {
        if (event.key === KEYBOARD.ESC) {
            event.stopPropagation();
            callback();
        }
    };
    useEffect(() => {
        allElements.forEach((element) => {
            const target = element.current;
            if (target) {
                target.addEventListener('keyup', keyListener);
            }
        });
        return () => {
            allElements.forEach((element) => {
                const target = element.current;
                if (target) {
                    target === null || target === void 0 ? void 0 : target.removeEventListener('keyup', keyListener);
                }
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, ...allElements]);
}
